import React from "react";
import { Link as MuiLink } from "@mui/material";
import { NavLink } from "react-router-dom";

export function NavigationLink({ href, isExternal, children }) {
  if (isExternal) {
    return (
      <MuiLink
        href={href}
        style={{
          display: "block", textDecoration: "none", color: "unset",
        }}
      >
        {children}
      </MuiLink>
    );
  }

  return (
    <NavLink
      to={href}
      // Set empty activeClassName to prevent React Router v5 from applying the
      // default "active" class. This avoids background styling conflicts with
      // switch.css that targets the .active selector.
      activeClassName=""
      style={{
        display: "block", textDecoration: "none", color: "unset",
      }}
    >
      {children}
    </NavLink>
  );
}
